import { MapTo } from '@adobe/aem-react-editable-components';
import PreApprovedZipCode, { PreApprovedZipCodeEditConfig } from './PreApprovedZipCode';

export default MapTo('cob-corp-acquisition/components/creditonebank/pre-approved-zip-code')(PreApprovedZipCode, PreApprovedZipCodeEditConfig);